import React from 'react';
import PolicyPageLayout from './PolicyPageLayout'; // Assuming this layout component exists

const TermsAndConditionsPage = () => {
  return (
    <PolicyPageLayout title="Terms and Conditions">
      <div className="space-y-6">
        <p className="text-sm text-gray-500">Last updated: September 2, 2025</p>

        <p>
          Welcome to MonviStyles! These terms and conditions outline the rules and regulations for the use of MonviStyles's Website, located at monvistyles.com.
        </p>
        <p>
          By accessing this website, we assume you accept these terms and conditions. Do not continue to use MonviStyles if you do not agree to all of the terms and conditions stated on this page.
        </p>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Accounts</h2>
          <p>
            When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service. You are responsible for safeguarding your password and for any activities or actions under your password.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are and will remain the exclusive property of MonviStyles and its licensors. The Service is protected by copyright, trademark, and other laws of India. Our trademarks may not be used in connection with any product or service without the prior written consent of MonviStyles.
          </p>
        </div>
        
        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Prohibited Activities</h2>
          <p>
            You are expressly restricted from publishing any website material in any media without prior consent; selling, sublicensing, or commercializing any website material; using this website in any way that is or may be damaging to this website or impacts user access; and engaging in any data mining, data harvesting, or similar activity.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">5. Limitation of Liability</h2>
          <p>
            In no event shall MonviStyles, nor any of its officers, directors, and employees, be held liable for anything arising out of or in any way connected with your use of this website. MonviStyles shall not be held liable for any indirect, consequential, or special liability related to your use of this website.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">6. Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict of law provisions.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">7. Changes to These Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice prior to any new terms taking effect.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">8. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at: contact@monvistyles.com.
          </p>
        </div>
      </div>
    </PolicyPageLayout>
  );
};

export default TermsAndConditionsPage;
